import context from '@truckdown/systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted, computed } from 'vue';

interface IProps {
    section: string;
}

const getComputed = function (props: IProps) {
    return {
        title: computed(() => {
            if (props.section == 'favorites') {
                return "Let's add your favorites!";
            }
            else if (props.section == 'vendors') {
                return "Import your internal vendors";
            }
            else if (props.section == 'setup') {
                return "Activate your fleet features";
            }

            return "Welcome to TruckDown! Let's get your Fleet account set up.";
        }),
        para1: computed(() => {
            if (props.section == 'favorites') {
                return "The next step is to start you off with a solid list of favorites for your account.  Favorites make it easy for you to contact vendors you want to do business with.";
            }
            else if (props.section == 'vendors') {
                return "Upload a list of vendors you currently use and out team will match them with our database and flag them as your favorites.";
            }
            else if (props.section == 'setup') {
                return "Enter your billing address and we will activate fleet features on your account free for 3 months!";
            }

            return "We're thrilled that you have put your trust in us to provide 24/7 Access to 40,000 Verified Heavy-Duty Repair Vendors.";
        }),
        para2: computed(() => {
            if (props.section == 'favorites') {
                return "Selecting dealer networks here will ensure those network always show first when you run a search and they have location in the area!";
            }
            else if (props.section == 'vendors') {
                return "Uploading your internal vendor list ensure you and your whole team can build upon and maintain the relationships you already have with vendors.";
            }
            else if (props.section == 'setup') {
                return "There is no cost to you for activating the 3 month trial period.  After 3 months your fleet features will be deactivated unless you choose to continue them.";
            }

            return "Completing these 4 steps will let you unlock the full TruckDown experience.  The first step is to invite your colleagues so you can share vendor information between your whole team.";
        })
    };
}

export default defineComponent({
    props: {
        section: {
            type: String,
            required: true
        }
    },
    name: "fleet-setup-step-title",
    emits: [],
    components: {
    },
    setup: function (props: IProps, ctx: any) {
        const computed = getComputed(props);

        return {
            ...computed
        };
    }
});